import { ServicesOffered } from "../../common";
import { DealerStore } from "../dealerStoreType";
import styles from '../DealerLocator.module.scss';

interface DealerLocatorServicesOfferedProps {   
    servicesOfferedTitle: string;
    store: DealerStore;
  }
  
  export const DealerLocatorServicesOffered = ({
    servicesOfferedTitle,
    store,
  }: DealerLocatorServicesOfferedProps) => {
    const { services } = store;
    return (
        <div
        className={`d-flex flex-column order-lg-3 mt-3 ${styles['resp-width']}`}
      >
        <ServicesOffered
          title={servicesOfferedTitle}
          servicesOffered={services}
        />
      </div>
  )};
  